import React from "react";
import PropTypes from "prop-types";

class GlobalCountryInfoPanel extends React.Component {
  render() {
    if (this.props.tabLoading) { return <div></div>; }

    if (!this.props.countrySelected) {
      return <table>
        <tbody>
          <tr>
            <td className="country-name" colSpan={2}>Global</td>
          </tr>
          <tr>
            <td className="year" colSpan={2}>{this.props.filterYear}</td>
          </tr>
          <tr>
            <td>Surveyed cities</td>
            <td>{this.props.surveyedCitiesGlobal}</td>
          </tr>
          <tr>
            <td>Cities added to survey this year</td>
            <td>{this.props.newThisYearGlobal}</td>
          </tr>
          <tr>
            <td>Average tariff</td>
            <td>{this.props.averagePriceGlobal}</td>
          </tr>
          <tr>
            <td>Average increase</td>
            <td>{this.props.tariffIncreaseGlobal}</td>
          </tr>
          {
            +this.props.filterYear === 2020 && this.props.tariffIncreaseGlobalExcludeHarare && (
              <tr>
                <td>Average increase(excl Harare)</td>
                <td>{this.props.tariffIncreaseGlobalExcludeHarare}</td>
              </tr>
            )
          }
        </tbody>
      </table>;
    }

    if (this.props.countryNotSurveyedMessage) {
      return <table>
        <tbody>
          <tr>
            <td className="country-name" colSpan={2}>{this.props.countryName}</td>
          </tr>
          <tr>
            <td className="year" colSpan={2}>{this.props.filterYear}</td>
          </tr>
          <tr>
            <td className="year" colSpan={2}>{this.props.countryNotSurveyedMessage}</td>
          </tr>
        </tbody>
      </table>;
    } else {
      return <table>
        <tbody>
          <tr>
            <td className="country-name" colSpan={2}>{this.props.countryName}</td>
          </tr>
          <tr>
            <td className="year" colSpan={2}>{this.props.filterYear}</td>
          </tr>
          <tr>
            <td>Surveyed cities</td>
            <td>{this.props.surveyedCities}</td>
          </tr>
          <tr>
            <td>Cities added to survey this year</td>
            <td>{this.props.newThisYear}</td>
          </tr>
          <tr>
            <td>Average tariff</td>
            <td>{this.props.averagePrice}</td>
          </tr>
          <tr>
            <td>Average increase</td>
            <td>{this.props.tariffIncrease}</td>
          </tr>
        </tbody>
      </table>;
    }
  }
}

GlobalCountryInfoPanel.propTypes = {
  tariffIncrease: PropTypes.string,
  filterYear: PropTypes.number,
  averagePrice: PropTypes.string,
  surveyedCities: PropTypes.number,
  countrySelected: PropTypes.bool.isRequired,
  tabLoading: PropTypes.bool.isRequired,
  countryName: PropTypes.string,
  countryNotSurveyedMessage: PropTypes.string,
  surveyedCitiesGlobal: PropTypes.number,
  newThisYearGlobal: PropTypes.number,
  averagePriceGlobal: PropTypes.string,
  tariffIncreaseGlobal: PropTypes.string,
  tariffIncreaseGlobalExcludeHarare: PropTypes.string,
  newThisYear: PropTypes.number
};

export default GlobalCountryInfoPanel;
